import React from 'react'
import PropTypes from 'prop-types'
import { MdDeveloperBoard } from "@react-icons/all-files/md/MdDeveloperBoard";
import { MdSubscriptions } from "@react-icons/all-files/md/MdSubscriptions";
import { MdChromeReaderMode } from "@react-icons/all-files/md/MdChromeReaderMode";
import { MdWidgets } from "@react-icons/all-files/md/MdWidgets";
import { MdCast } from "@react-icons/all-files/md/MdCast";
import { MdVideocam } from "@react-icons/all-files/md/MdVideocam";
import HowToReg from './custom/svg/HowToReg';
import HowToVote from './custom/svg/HowToVote';
import Link from 'next/link'

function SidebarCTA({ heading, subText, source }) {
    return (
        <div className='sidebar-cta'>
            <Link href='/'>
                <a className='d-none d-lg-block'>
                    <div className="logo-wrapper mb-4">
                        {
                            source ?
                                <>
                                    {
                                        source == "scholarly" && 
                                        <img width="100px" src="/images/scholarly-logo.png" alt="scholarly-logo" />
                                    }
                                    {
                                        source == "corporategurukul" && 
                                        <img width="100px" src="/images/corporategurukul-logo.png" alt="corporategurukul-logo" />
                                    }
                                </>
                                :
                                <picture>
                                    <source type="image/webp" srcSet={process.env.NEXT_PUBLIC_BRAND_LOGO} />
                                    <source type="image/png" srcSet={process.env.NEXT_PUBLIC_BRAND_LOGO} />
                                    <img src={process.env.NEXT_PUBLIC_BRAND_LOGO} alt="brand-logo" width="112px" height="auto" />
                                </picture>
                        }
                    </div>
                </a>
            </Link>
            <h4 className="mb-3 d-none d-lg-block">{heading}</h4>
            <h4 className='mb-3 txt-24--subheader bold d-lg-none'>{subText}</h4>
            <div className="yellow-hr mb-4"></div>
            <ul className="sidebar-cta--list mt-md-5">
                <li><h5><MdDeveloperBoard className='text-primary mr-3' fontSize="26px" />Free Diagnostic Tests</h5></li>
                <li><h5><MdSubscriptions className='text-primary mr-3' fontSize="26px" />Detailed Test Reports</h5></li>
                <li><h5><MdChromeReaderMode className='text-primary mr-3' fontSize="26px" />Personalised Course Plans</h5></li>
                <li><h5><MdWidgets className='text-primary mr-3' fontSize="26px" />In-depth Videos</h5></li>
                <li><h5><MdCast className='text-primary mr-3' fontSize="26px" />Thematic Worksheets</h5></li>
                <li><h5><HowToReg className='text-primary mr-3' fontSize="26px" /> Interactive Lessons</h5></li>
                <li><h5><MdVideocam className='text-primary mr-3' fontSize="26px" />Actual Board-style Mock Tests</h5></li>
                <li><h5><HowToVote className='text-primary mr-3' fontSize="26px" />Dynamic Score Predictor</h5></li>
            </ul>
        </div>
    )
}

SidebarCTA.propTypes = {
    heading: PropTypes.string,
    subText: PropTypes.node,
    source: PropTypes.string
}
SidebarCTA.defaultProps = {
    heading: 'Welcome back!',
    subText: 'Login to the most advanced \n e-learning platform.',
    source: ''
}

export default SidebarCTA

